import { useCallback } from 'react';

import { translationKeys } from '../../../../translations';

import { CustomPatientGroupsFormController } from './CustomPatientGroupsForm.types';

export const useNotUniqueCustomPatientGroupNameErrorHandler = ({
   setError,
}: Pick<CustomPatientGroupsFormController, 'setError'>): VoidFunction => {
   return useCallback(() => {
      return setError('name', { message: translationKeys.noUniqueName });
   }, [setError]);
};
